(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
  "use strict";

  // Menu toggle functionality
  document.querySelectorAll('.category-drawer-toggle, .category-drawer-overlay, .category-drawer-drawer-close').forEach(function(element) {
    element.addEventListener('click', function() {
      document.querySelector('.category-drawer-toggle')?.classList.toggle('clicked');
      document.querySelector('.category-drawer-drawer-close')?.classList.toggle('clicked');
      document.querySelector('.category-drawer-overlay')?.classList.toggle('active');
      document.querySelector('.category-drawer')?.classList.toggle('active');
      document.body.classList.toggle('overflow-hidden');
    });
  });

  // Create back buttons for all submenus that are children of list items
  document.querySelectorAll('.custom-nav-submenu').forEach(submenu => {
    // Only add back button if this is a child menu (has a parent li)
    if (submenu.parentElement.closest('li')) {
      const backButton = document.createElement("li");
      backButton.className = "back-btn";
      backButton.innerHTML = `
        <a href="#" class="flex items-center gap-2">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          ${window.translations?.back || 'Back'}
        </a>
      `;
      
      submenu.insertBefore(backButton, submenu.firstChild);
      
      backButton.addEventListener("click", function(e) {
        e.preventDefault();
        // Hide current submenu
        submenu.classList.remove('in-view');
        // Show parent menu
        const parentMenu = submenu.parentElement.closest('ul.custom-nav-submenu');
        if (parentMenu) {
          parentMenu.classList.remove('off-view');
        }
      });
    }
  });

  // Handle submenu toggles
  document.querySelectorAll('.custom-sub-toggle').forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      const parentLi = this.closest('li');
      const submenu = parentLi.querySelector('.custom-nav-submenu');
      
      if (submenu) {
        // Hide all other submenus at this level
        parentLi.parentElement.querySelectorAll('.custom-nav-submenu').forEach(sm => {
          if (sm !== submenu) sm.classList.remove('in-view');
        });
        
        // Toggle current submenu
        submenu.classList.toggle('in-view');
        
        // Hide parent menu if this is a submenu
        const parentMenu = parentLi.closest('ul.custom-nav-submenu');
        if (parentMenu && submenu.classList.contains('in-view')) {
          parentMenu.classList.add('off-view');
        } else if (parentMenu) {
          parentMenu.classList.remove('off-view');
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
